<template>
  <div>
    <el-form
      v-if="isFba"
      :disabled="readonly"
      class="section"
      style="flex-direction: row;"
    >
      <span style="display: flex;align-items: center;width: 64px">
        {{ $t('FbaJob.ValueAddedServices') }}
      </span>
      <el-checkbox-group v-model="selectedLocalAddedService" @change="addedServiceChangeHandler">
        <el-checkbox
          v-for="item in localAddedService"
          :key="item.code"
          :label="item.code"
          :disabled="item.code === 'signHBL' && form.mblOnly"
          style="margin-left: 8px;margin-right: 8px"
          @change="val => singleAddedServiceChangeHandler(val, item)"
        >
          {{ item.chineseName }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <el-form
      v-if="!isFba"
      :disabled="readonly"
      class="section"
      style="flex-direction: row;"
    >
      <el-checkbox v-model="form.booking" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.insure"
        no="isInsure"
        style="margin-left: -20px;"
      >{{ $t('SeaExport.InsureInfo') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.signMBL"
        no="signMBL"
        style="margin-left: -20px;"
        @change="pm.isMBLChange()"
      >MB/L
      </el-checkbox>
      <el-checkbox
        v-model="form.signHBL"
        no="signHBL"
        style="margin-left: -20px;"
        :disabled="form.mblOnly"
        @change="pm.isHBLChange()"
      >HB/L
      </el-checkbox>
      <el-checkbox v-model="form.virtualHBL" no="virtualHBL" style="margin-left: -20px;" @change="pm.virtualHblChange()">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px;">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.hds" no="hds" style="margin-left: -20px;">HDS</el-checkbox>
      <el-checkbox v-model="form.comercialInspectation" no="comercialInspectation" style="margin-left: -20px;">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="form.heating" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="form.itmService" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
      <el-checkbox v-model="form.manifest" no="manifest" style="margin-left: -20px;">{{ $t('SeaExport.Manifest') }}</el-checkbox>
      <el-checkbox v-model="form.seaRailwayTransportation" no="seaRailwayTransportation" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_SeaRailTransport') }}</el-checkbox>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <tab-booking-FCLUICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.viewable" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input
          :value="form.jobNo"
          :disabled="true"
        />
      </el-form-item>
      <template v-if="isZY">
        <el-form-item slot="saleProductCode">
          <line-label slot="label" class="blue" :label="$t('SeaExport.AllowSaleProduct')" />
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_AllowSaleProduct"
            filterable
            no="allowSaleProduct"
            clearable
            :data-filter-function="p => {
              if (!p.statusEnabled) {
                return false
              }
              return isFba ? p.fbaSea : p.seaExportEnabled
            }"
            :default-value="this.form.saleProductCode || ''"
            :disabled="readonly"
            @parentCallBack="p => {this.form.saleProductCode = p.value}"
          />
        </el-form-item>
        <el-form-item slot="fullOrInside">
          <line-label slot="label" class="blue" :label="$t('SeaExport.FullOrInside')" />
          <cargo-advance-select
            :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
            no="fullOrInside"
            clearable
            :default-value="this.form.fullOrInside || ''"
            :disabled="readonly"
            @parentCallBack="p => {this.form.fullOrInside = p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.customerId.viewable" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageB"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <img
              :class="form.customerId&&readonly?'':'not-click'"
              :src="sopPic"
              width="18"
              height="28"
              class="sop-img"
              style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
              @click="pm.sopChangeCustomerIdHandler()"
            >
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageB"
            :content="warningImageBTip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-sales-company-select
            v-if="!isFba"
            no="customerId"
            class="shipper-selector"
            popper-class="shipper-selector-popper"
            :method-params="{customer:true,companyLob:'seaExport',active:true}"
            :check-credit="true"
            :default-value="form.customerId||''"
            :disabled="readonly || !elementDict.customerId.writable || !customerEnabled"
            :job="form"
            style="flex: 1;"
            :class="importDifferenceField.customerId ? 'red-border' : ''"
            :latest-used-data-key="elementDict.customerId.userCustomContent && elementDict.customerId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-customerId' : ''"
            @parentCallBack="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
          />
          <cargo-company-select
            v-if="isFba"
            no="customerId"
            class="shipper-selector"
            popper-class="shipper-selector-popper"
            :method-params="{customer:true,companyLob:'seaExport',active:true, fba:true}"
            :check-credit="true"
            :job="form"
            :default-value="form.customerId||''"
            :disabled="readonly || !elementDict.customerId.writable || !customerEnabled"
            style="flex: 1;"
            :data-filter-function="fbaCustomerIdFilter"
            @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customerProperty.viewable" slot="customerProperty">
        <line-label slot="label" :class="elementDict.customerProperty.isRequire ? 'blue' : ''" :label="elementDict.customerProperty.label" />
        <el-tooltip :content="customerTip" placement="bottom">
          <span
            v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            class="orange"
          >LV{{ customerLevel.level }}</span>
          <span
            v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
            style="color:#D3A73B"
          >&nbsp;{{ customerLevel.customerName }}</span>
          <span
            v-show="contractStatusLabel"
            class="red"
          >&nbsp;({{ contractStatusLabel }})</span>
          <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
          <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
            <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
          </span>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.viewable" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <div style="display: flex">
          <el-select
            v-model="form.customerContact"
            :disabled="readonly || !elementDict.customerContact.writable"
            no="customerContact"
            field-name="contactPerson"
            filterable
            :allow-create="true"
            :class="importDifferenceField.customerContact ? 'red-border' : ''"
          >
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.contactPerson"
              :value="item.contactPerson"
            />
          </el-select>&nbsp;
          <el-link
            v-show="!isShowContactPersonDetail"
            no="customerContactLink"
            :class="form.customerContact?'':'not-click'"
            @click="showContactDialog"
          >{{ $t('SeaExport.Detail') }}
          </el-link>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.containerLoadType.viewable" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="form.containerLoadType"
          no="containerLoadType"
          :disabled="readonly || !elementDict.containerLoadType.writable || !(isEdit && lclslaveEnabled)"
          :class="importDifferenceField.containerLoadType ? 'red-border' : ''"
          @change="val=>{pm.containerLoadTypeChange(val)}"
        >
          <el-option
            v-for="(item,index) in (containerLoadTypes)"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.viewable" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <el-select v-model="form.cargoType" :disabled="readonly || !elementDict.cargoType.writable" :class="importDifferenceField.cargoType ? 'red-border' : ''" filterable @change="val=>{cargoTypeChange(val)}">
          <el-option
            v-for="(item,index) in cargoType4JobSelect"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.salesChannel.viewable" slot="salesChannel">
        <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
        <el-input
          :value="form.salesChannel"
          :disabled="true"
        />
      </el-form-item>
      <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
      <el-form-item v-if="elementDict.channelNo.viewable" slot="channelNo">
        <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
        <el-input :value="form.channelNo" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.trustFromJob.viewable" slot="trustFromJob">
        <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
        <el-input :value="form.trustFromJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.viewable" slot="relatedJob">
        <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
        <el-input :value="form.relatedJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNo.viewable" slot="quotationNo">
        <line-label slot="label" :class="elementDict.quotationNo.isRequire ? 'blue' : ''" :label="elementDict.quotationNo.label" />
        <el-input :value="form.quotationNo" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingDate.viewable" slot="bookingDate">
        <line-label slot="label" :class="elementDict.bookingDate.isRequire ? 'blue' : ''" :label="elementDict.bookingDate.label" />
        <el-date-picker
          v-model="form.bookingDate"
          no="bookingDate"
          :disabled="readonly || !elementDict.bookingDate.writable"
          type="date"
          style="width:100%;"
          clearable
          :class="importDifferenceField.bookingDate ? 'red-border' : ''"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.viewable" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex;">
          <el-date-picker
            no="etd"
            class="departure-date-picker"
            :value="form.etd"
            :disabled="readonly || !elementDict.etd.writable || (form.lclMasterUuid?true:!etdEnabled) || canEditInternalDelegatedJobField || !isJydEditJobFields || provisionEtdLocked"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1;margin-right: 5px"
            :class="importDifferenceField.etd ? 'red-border' : ''"
            @input="etdChange"
            @change="onFieldChange('etd')"
          />
          <span>{{ form.sailingDay|filterWeek }}</span>
        </div>
        <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.viewable" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.eta"
            no="eta"
            :disabled="readonly || !elementDict.eta.writable || !lclslaveEnabled || canEditInternalDelegatedJobField"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            :class="importDifferenceField.eta ? 'red-border' : ''"
            @input="etaChange"
          />
          <span>{{ form.etaSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.atd.viewable" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            :value="form.atd"
            no="atd"
            :disabled="readonly || !elementDict.atd.writable || !lclslaveEnabled || canEditInternalDelegatedJobField"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="atdChange"
          />
          <span>{{ form.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.viewable" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.ata"
            no="ata"
            :disabled="readonly || !elementDict.ata.writable || !lclslaveEnabled || canEditInternalDelegatedJobField"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="ataChange"
          />
          <span>{{ form.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.viewable" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker
          v-model="form.customsDate"
          no="customsDate"
          type="date"
          :disabled="readonly || !elementDict.customsDate.writable || !isJydUpdateCustomsDate"
          style="width:100%"
          :class="importDifferenceField.customsDate ? 'red-border' : ''"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode">
        <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
        <cargo-advance-select
          no="dispatchingPlaceCode"
          :select-type="selectTypeNames.basic_data_Seaport"
          :placeholder="$t('SeaExport.PlaceHolderPOR')"
          filterable
          :default-value="form.dispatchingPlaceCode"
          :disabled="readonly || !elementDict.dispatchingPlaceCode.writable"
          tag-name="englishName"
          style="flex:1"
          :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
          @parentCallBack="p=>{pm.changeDispatchingPlaceCode(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlace.viewable" slot="dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
        <el-input
          v-model="form.dispatchingPlace"
          :disabled="readonly || !elementDict.dispatchingPlace.writable"
          no="dispatchingPlace"
          :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''"
          @change="pm.cargoDocChangeHandler();pm.changeDispatchingPlace()"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.loadingPortCode.viewable" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <div style="display: flex; justify-content: space-between">
          <cargo-advance-select
            ref="loadingPortCode"
            no="loadingPortCode"
            :disabled="readonly || !elementDict.loadingPortCode.writable"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.loadingPortCode"
            tag-name="englishName"
            style="flex:1"
            :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
            :latest-used-data-key="elementDict.loadingPortCode.userCustomContent && elementDict.loadingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-loadingPortCode' : ''"
            @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeLoadingPort();pm.setPlannerChange()}"
          />
          <template v-if="elementDict.transferPortCode.viewable">
            &nbsp;
            <el-checkbox v-model="form.transfering" :disabled="readonly || !elementDict.loadingPortCode.writable" no="transfering" style="padding-left:2px;" @change="pm.updateSecondVesselInfo()">{{ fieldDict.transfering.label }}</el-checkbox>
          </template>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.transferPortCode.viewable && form.transfering" slot="transferPortCode">
        <line-label slot="label" :class="elementDict.transferPortCode.isRequire ? 'blue' : ''" :label="elementDict.transferPortCode.label" />
        <cargo-advance-select
          no="transferPortCode"
          :disabled="readonly || !elementDict.transferPortCode.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.transferPortCode"
          @parentCallBack="p=>{form.transferPortCode=p.value;pm.updateSecondVesselInfo()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          no="dischargingPortCode"
          :disabled="readonly || !elementDict.dischargingPortCode.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode"
          :class="importDifferenceField.dischargingPortCode ? 'red-border' : ''"
          :latest-used-data-key="elementDict.dischargingPortCode.userCustomContent && elementDict.dischargingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-dischargingPortCode' : ''"
          @parentCallBack="p=>{pm.dischargingPortCodeChange(p.value,form.carrierId);pm.cargoDocChangeHandler();pm.changeDischargingPort()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          no="destinationPortCode"
          class="port-of-delivery-selector"
          popper-class="port-of-delivery-selector-popper"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode"
          :disabled="readonly || !elementDict.destinationPortCode.writable"
          :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
          :latest-used-data-key="elementDict.destinationPortCode.userCustomContent && elementDict.destinationPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationPortCode' : ''"
          @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeDestinationPort()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfDeliveryRegion.viewable" slot="placeOfDeliveryRegion">
        <line-label slot="label" :class="elementDict.placeOfDeliveryRegion.isRequire ? 'blue' : ''" :label="elementDict.placeOfDeliveryRegion.label" />
        <cargo-advance-select
          no="placeOfDeliveryRegion"
          :select-type="selectTypeNames.basic_data_Region"
          filterable
          :default-value="form.placeOfDeliveryRegion"
          :disabled="readonly || !elementDict.placeOfDeliveryRegion.writable"
          :class="importDifferenceField.placeOfDeliveryRegion ? 'red-border' : ''"
          @parentCallBack="p=>{form.placeOfDeliveryRegion=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transshipmentTransportationModeCode && elementDict.transshipmentTransportationModeCode.viewable" slot="transshipmentTransportationModeCode">
        <line-label slot="label" :class="elementDict.transshipmentTransportationModeCode.isRequire ? 'blue' : ''" :label="elementDict.transshipmentTransportationModeCode.label" />
        <cargo-advance-select
          no="transportationMode"
          :static-options="transportationModeInfos"
          :filter-tag-names="['chineseName', 'englishName', 'code']"
          filterable
          :disabled="readonly || !elementDict.transshipmentTransportationModeCode.writable"
          :tag-name="'englishName'"
          :default-value="form.transshipmentTransportationModeCode"
          @parentCallBack="p=>{form.transshipmentTransportationModeCode=p.value}"
        />
      </el-form-item>
      <!--询价编号-->
      <el-form-item v-if="elementDict.inquiryPriceNo && elementDict.inquiryPriceNo.viewable" slot="inquiryPriceNo">
        <line-label slot="label" :class="elementDict.inquiryPriceNo.isRequire ? 'blue' : ''" :label="elementDict.inquiryPriceNo.label" />
        <el-input no="inquiryPriceNo" :value="form.inquiryPriceNo" class="input2" disabled />
      </el-form-item>
      <!--关联港前报价单号-->
      <el-form-item v-if="elementDict.prePortQuotationNo && elementDict.prePortQuotationNo.viewable" slot="prePortQuotationNo">
        <line-label slot="label" :class="elementDict.prePortQuotationNo.isRequire ? 'blue' : ''" :label="elementDict.prePortQuotationNo.label" />
        <el-input no="prePortQuotationNo" :value="form.prePortQuotationNo" class="input2" disabled />
      </el-form-item>
      <!--关联尾程报价单号-->
      <el-form-item v-if="elementDict.lastMileQuotationNo && elementDict.lastMileQuotationNo.viewable" slot="lastMileQuotationNo">
        <line-label slot="label" :class="elementDict.lastMileQuotationNo.isRequire ? 'blue' : ''" :label="elementDict.lastMileQuotationNo.label" />
        <el-input no="lastMileQuotationNo" :value="form.lastMileQuotationNo" class="input2" disabled />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselLine.viewable" slot="vesselLine">
        <line-label slot="label" :class="elementDict.vesselLine.isRequire ? 'blue' : ''" :label="elementDict.vesselLine.label" />
        <el-input
          :value="pm.vesselLine"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input
          v-model="form.destinationPlace"
          :disabled="readonly || !elementDict.destinationPlace.writable"
          no="destinationPlace"
          :class="importDifferenceField.destinationPlace ? 'red-border' : ''"
          @change="pm.cargoDocChangeHandler();pm.changeDestinationPlace()"
        />
      </el-form-item>
      <!-- 船公司 -->
      <el-form-item v-show="elementDict.carrierId.viewable" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-company-select
          ref="shippingCompany"
          no="carrierId"
          :disabled="readonly || !elementDict.carrierId.writable || !carrierIdEnabled"
          :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
          :default-value="form.carrierId||''"
          :class="importDifferenceField.carrierId ? 'red-border' : ''"
          :latest-used-data-key="elementDict.carrierId.userCustomContent && elementDict.carrierId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-carrierId' : ''"
          @change="p=>{pm.carrierChangeHandler(form.dischargingPortCode, p.value, this.scacList, this.carrierScacEdit)}"
        />
      </el-form-item>
      <!-- 船公司SCAC -->
      <el-form-item v-if="elementDict.carrierScac && elementDict.carrierScac.viewable" slot="carrierScac">
        <line-label slot="label" :class="elementDict.carrierScac.isRequire ? 'blue' : ''" :label="elementDict.carrierScac.label" />
        <cargo-advance-select
          no="carrierScac"
          filterable
          :custom-label="(item)=>`[${item.code}]${item.englishName?item.englishName:item.code}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :static-options="scacList"
          tag-value="code"
          :disabled="readonly || !carrierScacEdit || !elementDict.carrierScac.writable"
          :default-value="form.carrierScac||''"
          @parentCallBack="p=>{form.carrierScac = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierWebsite && elementDict.carrierWebsite.viewable" slot="carrierWebsite">
        <line-label slot="label" :class="elementDict.carrierWebsite.isRequire ? 'blue' : ''" :label="elementDict.carrierWebsite.label" />
        <cargo-textarea v-model="form.carrierWebsite" no="carrierWebsite" type="textarea" :row="3" :disabled="readonly || !elementDict.carrierWebsite.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.viewable && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          v-if="!bookingAgentDataProviderChange"
          no="bookingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          filterable
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
          :default-value="form.bookingAgent||''"
          :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
          :latest-used-data-key="elementDict.bookingAgent.userCustomContent && elementDict.bookingAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-bookingAgent' : ''"
          @parentCallBack="p=>{pm.bookingAgentChangeHandler(p)}"
        />
        <cargo-advance-select
          v-if="bookingAgentDataProviderChange"
          no="bookingAgent"
          :cache="false"
          :select-type="selectTypeNames.basic_data_Company"
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :default-value="form.bookingAgent||''"
          :static-options="pm.bookingAgentArray"
          :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
          :latest-used-data-key="elementDict.bookingAgent.userCustomContent && elementDict.bookingAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-bookingAgent' : ''"
          @parentCallBack="p=>{pm.bookingAgentChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierAgentId.viewable" slot="carrierAgentId">
        <line-label slot="label" :class="elementDict.carrierAgentId.isRequire ? 'blue' : ''" :label="elementDict.carrierAgentId.label" />
        <cargo-company-select
          no="carrierAgentId"
          :disabled="readonly || !elementDict.carrierAgentId.writable || !lclslaveEnabled"
          :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
          :default-value="form.carrierAgentId||''"
          :class="importDifferenceField.carrierAgentId ? 'red-border' : ''"
          @change="p=>{form.carrierAgentId=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.terminalCompany.viewable" slot="terminalCompany">
        <line-label slot="label" :class="elementDict.terminalCompany.isRequire ? 'blue' : ''" :label="elementDict.terminalCompany.label" />
        <cargo-company-select
          no="terminalCompany"
          :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
          :default-value="form.terminalCompany||''"
          :disabled="readonly || !elementDict.terminalCompany.writable"
          style="width: 100%"
          :class="importDifferenceField.terminalCompany ? 'red-border' : ''"
          @change="p=>{JobUtils.terminalCompanyChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.viewable" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <el-select
          v-model="form.cargoSource"
          no="cargoSource"
          :disabled="readonly || !elementDict.cargoSource.writable || !cargoSourceEnabled"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
          :class="importDifferenceField.cargoSource ? 'red-border' : ''"
          @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
        >
          <el-option
            v-for="(item,index) in CARGO_SOURCES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-show="elementDict.customJobType.viewable" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :default-value="form.customJobType"
          :disabled="readonly || !elementDict.customJobType.writable"
          :tag-name="isZh?'name':'englishName'"
          :method-params="{type:form.lob}"
          :static-options="customJobTypeList"
          :class="importDifferenceField.customJobType ? 'red-border' : ''"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.secondaryCustomJobType.viewable && form.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
        <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
        <cargo-advance-select
          ref="secondaryCustomJobType"
          no="secondaryCustomJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :cache="false"
          :default-value="form.secondaryCustomJobType"
          :disabled="readonly || !elementDict.secondaryCustomJobType.writable"
          :tag-name="isZh?'name':'englishName'"
          :static-options="secondaryCustomJobTypeList"
          @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.viewable" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageC"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <img
              :class="form.destinationAgent&&readonly?'':'not-click'"
              :src="sopPic"
              width="18"
              height="28"
              class="sop-img"
              style="padding: 5px 0;cursor: pointer"
              @click="pm.sopChangeHandler()"
            >
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageC"
            :content="warningImageCTip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-advance-select
            no="destinationAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :disabled="readonly || !elementDict.destinationAgent.writable || !lclslaveEnabled"
            :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
            :default-value="form.destinationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :class="importDifferenceField.destinationAgent ? 'red-border' : ''"
            :latest-used-data-key="elementDict.destinationAgent.userCustomContent && elementDict.destinationAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationAgent' : ''"
            @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
          <cargo-advance-select
            v-if="overseaAgentDataProviderChange"
            no="destinationAgent2"
            :select-type="selectTypeNames.basic_data_Company"
            :cache="false"
            :disabled="readonly || !elementDict.destinationAgent.writable || !lclslaveEnabled"
            :default-value="form.destinationAgent||''"
            filterable
            :check-credit="true"
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :static-options="pm.destinationAgentArray"
            :latest-used-data-key="elementDict.destinationAgent.userCustomContent && elementDict.destinationAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationAgent' : ''"
            @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.viewable && form.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="sopImageA"
            :content="$t('SeaExport.SOPReceiver')"
            placement="right-end"
          >
            <div>
              <img
                :class="form.designationAgent&&readonly?'':'not-click'"
                :src="sopPic"
                width="18"
                height="28"
                class="sop-img"
                style="padding: 5px 0;cursor: pointer"
                @click="pm.sopChangeBookingAgentHandler()"
              >
            </div>
          </el-tooltip>
          <el-tooltip
            v-show="showWarningImageA"
            :content="warningImageATip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-advance-select
            no="designationAgent"
            class="designation-agent-selector"
            popper-class="designation-agent-selector-popper"
            :select-type="selectTypeNames.basic_data_Company"
            :disabled="readonly || !elementDict.designationAgent.writable || !designationAgentEnabled"
            :method-params="{designationAgent:true,active:true}"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
          <cargo-advance-select
            v-if="overseaAgentDataProviderChange"
            no="designationAgent2"
            :select-type="selectTypeNames.basic_data_Company"
            :cache="false"
            :disabled="readonly || !elementDict.designationAgent.writable || !designationAgentEnabled"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :static-options="pm.designationAgentArray"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.exChangeAgent.viewable" slot="exChangeAgent">
        <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
        <cargo-company-select
          no="exChangeAgent"
          :disabled="readonly || !elementDict.exChangeAgent.writable || !form.destinationPortService"
          :method-params="{bookingAgent:true,active:true}"
          :default-value="form.exChangeAgent||''"
          @change="onExChangeAgentChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportSource.viewable" slot="transportSource">
        <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_TransportSource"
          no="transportSource"
          :default-value="form.transportSource"
          :disabled="readonly || !elementDict.transportSource.writable"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.transportSource=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.statisticArea.viewable" slot="statisticArea">
        <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_StatisticArea"
          no="statisticArea"
          :default-value="form.statisticArea"
          :disabled="readonly || !elementDict.statisticArea.writable"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.statisticArea=item.value"
        />
      </el-form-item>
      <template v-if="elementDict.customsDeclaration && elementDict.customsDeclaration.viewable" slot="customsDeclaration">
        <!--关单信息-->
        <customs-declaration
          v-if="slaveCustomsDeclarationEnable"
          ref="customsDeclaration"
          no="customsDeclaration"
          :job="form"
          :is-editing="!readonly && elementDict.customsDeclaration.writable"
          :del-po-items-uuids="delPoItemsUuids"
          @quantityActualChange="quantityActualChange"
          @weightActualChange="weightActualChange"
          @cubageActualChange="cubageActualChange"
        />
      </template>
      <el-form-item v-if="elementDict.localService.viewable" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="form.warehousing"
          :disabled="readonly || !elementDict.localService.writable"
          no="warehousing"
          style="display: block;"
          @change="pm.loadingTermChange('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.landTransportation"
          :disabled="readonly || !elementDict.localService.writable"
          no="landTransportation"
          style="display: block;"
          @change="pm.loadingTermChange('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.selfDeliver"
          :disabled="readonly || !elementDict.localService.writable"
          no="selfDeliver"
          style="display: block;"
        >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
        </el-checkbox>
        <el-checkbox v-model="form.backUpWarehouse" :disabled="readonly || !elementDict.localService.writable" no="backUpWarehouse" style="display: block;" @change="pm.backUpWarehouseChange()">{{ $t('SeaExport.BackUpWarehouse') }} </el-checkbox>
        <el-checkbox v-model="form.otherService" :disabled="readonly || !elementDict.localService.writable" no="otherService" @change="pm.otherServiceChange()">{{ $t('SeaExport.Other') }} </el-checkbox>
        <el-input v-show="form.otherService" v-model="form.otherRemark" :disabled="readonly || !elementDict.localService.writable" :class="importDifferenceField.otherRemark ? 'red-border' : ''" no="otherRemark" maxlength="10" />
      </el-form-item>
      <el-form-item v-if="elementDict.portOfDestinationServices.viewable && !isFba && isBookingNew && form.destinationPortService" slot="portOfDestinationServices">
        <line-label slot="label" :class="elementDict.portOfDestinationServices.isRequire ? 'blue' : ''" :label="elementDict.portOfDestinationServices.label" />
        <el-checkbox
          v-model="form.dischargingPortDoor"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="dischargingPortDoor"
          style="display: block;"
        >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.usCustomsClearance"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="usCustomsClearance"
          style="display: block;"
        >{{ $t('queryJob.UsCustomsClearance') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.destPortCustomsClearance"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="destPortCustomsClearance"
          style="display: block;"
        >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
        </el-checkbox>
      </el-form-item>
      <el-form-item v-if="isFba && isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
        <el-checkbox-group v-model="selectedPodAddedService" :disabled="readonly" @change="addedServiceChangeHandler">
          <el-checkbox
            v-for="item in podAddedService"
            :key="item.code"
            :label="item.code"
            style="display:block"
            @change="val => singleAddedServiceChangeHandler(val, item)"
          >
            {{ item.chineseName }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <template v-if="elementDict.warehouseNo.viewable" slot="warehouseNo">
        <el-form-item v-if="!jingyuWarehouse" :class="warehouseNoRed?'warehouseClass':''">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <el-input
            v-model="form.warehouseNo"
            no="warehouseNo"
            style="margin-bottom: 10px;"
            :disabled="readonly || !elementDict.warehouseNo.writable || !pm.warehouseNoeditable"
          />
          <el-button
            :disabled="readonly || !elementDict.warehouseNo.writable || !(isEdit && isHbl)"
            no="ObtainTheWarehouseNo"
            type="primary"
            style="padding-left:13px;padding-right:13px;"
            @click="pm.clickWarehouseNoHandler()"
          >{{ $t('SeaExport.ObtainTheWarehouseNo') }}
          </el-button>
          <!--此功能屏蔽-->
          <!--<cargo-button-container :disabled="form.jobState!==0" @click="pm.autoAllocateExternalHandler()">
                  <el-button
                    type="primary"
                    style="padding-left:13px;padding-right:13px;"
                  >{{ $t('SeaExport.AutoDistribution') }}</el-button>
                </cargo-button-container>-->
        </el-form-item>
        <el-form-item v-if="jingyuWarehouse" :class="warehouseNoRed?'warehouseClass':''">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <warehouse-no-input
            v-model="form.warehouseNo"
            :job-warehouse-nos.sync="jobWarehouseNos"
            :job="form"
            no="warehouseNo2"
            style="margin-bottom: 10px;"
            :disabled="readonly || !elementDict.warehouseNo.writable || !pm.warehouseNoeditable"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.warehouseStatus.viewable" slot="warehouseStatus" no="WarehouseState">
        <line-label slot="label" :class="elementDict.warehouseStatus.isRequire ? 'blue' : ''" :label="elementDict.warehouseStatus.label" />
        <el-select
          v-model="form.warehouseStatus"
          :disabled="true"
          :placeholder="$t('Message.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE"
            :key="index"
            :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.masterBusinessNo.viewable" slot="masterBusinessNo">
        <line-label slot="label" :class="elementDict.masterBusinessNo.isRequire ? 'blue' : ''" :label="elementDict.masterBusinessNo.label" />
        <el-input
          :disabled="true"
          :value="form.lclMaster?form.lclMaster.jobNo:''"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.customerRefNo.viewable"
        id="customerRefNo"
        slot="customerRefNo"
        :class="customerRefNoRed?'warehouseClass':''"
      >
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <el-tooltip
          :disabled="!customerRefNoTip"
          :content="customerRefNoTip"
          placement="right-end"
        >
          <el-input
            v-model="form.customerRefNo"
            :disabled="readonly || !elementDict.customerRefNo.writable"
            no="customerRefNo"
            :class="customerRefNoTip?'red':''"
            @blur="pm.customerRefNoFocusOutHandler()"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.agentRefNo.viewable && form.cargoSource === 'NC'" id="agentRefNo" slot="agentRefNo">
        <line-label slot="label" :class="elementDict.agentRefNo.isRequire ? 'blue' : ''" :label="elementDict.agentRefNo.label" />
        <el-input v-model="form.agentRefNo" :disabled="readonly || !elementDict.agentRefNo.writable" no="agentRefNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.viewable" slot="poNo" :class="poNoRed?'warehouseClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input
          v-if="!openProjectConfig"
          v-model="form.poNo"
          :disabled="readonly || !elementDict.poNo.writable"
          no="poNo"
        />
        <cargo-project-select
          v-if="openProjectConfig"
          no="poNo"
          :default-value="form.poNo"
          :disabled="readonly || !elementDict.poNo.writable"
          :customer-id="form.customerId"
          :is-linked="isProjectLinkedCustomer"
          @change="p=>{form.poNo=p.value;form.projectName=p.projectName;changeProject()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.viewable && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="form.projectName" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.projectBatch.viewable && openProjectConfig" slot="projectBatch">
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="form.projectBatch" :disabled="readonly || !elementDict.projectBatch.writable" no="projectBatch" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.viewable" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          no="customsBroker"
          :disabled="readonly || !elementDict.customsBroker.writable || !customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="form.customsBroker||''"
          :placeholder="!customsBrokerEnabled? $t('SeaExport.PleaseTickCustomsDeclarationOption'):$t('CargoMsg.Cargo_keyWordsTip')"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.viewable" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="readonly || !elementDict.customsDeclarationType.writable || !customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
          filterable
          :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{form.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.viewable" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          :select-type="selectTypeNames.basic_data_TradeTerm"
          filterable
          :default-value="form.tradeTerm"
          :disabled="readonly || !elementDict.tradeTerm.writable"
          @parentCallBack="p=>{form.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.haulageCompany.viewable" slot="haulageCompany">
        <line-label slot="label" :class="elementDict.haulageCompany.isRequire ? 'blue' : ''" :label="elementDict.haulageCompany.label" />
        <cargo-company-select
          no="carryingCmp"
          :disabled="readonly || !elementDict.haulageCompany.writable || !form.landTransportation"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.carryingCmp||''"
          :placeholder="!form.landTransportation?$t('SeaExport.PleaseTickDoorLoadingDeliveryOption'):$t('CargoMsg.Cargo_keyWordsTip')"
          @change="p=>{pm.carryingCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.DomesticWarehouse')">
        <cargo-company-select
          no="warehouseCmp"
          :disabled="readonly || !warehouseEabled"
          :method-params="{warehouse:true,active:true}"
          :default-value="Number(fbaJob.domesticWarehouse)||''"
          :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseCmp.viewable && !isFba" slot="warehouseCmp">
        <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
        <cargo-company-select
          no="warehouseCmp"
          :disabled="readonly || !elementDict.warehouseCmp.writable || !warehouseEabled"
          :method-params="{warehouse:true,active:true}"
          :default-value="form.warehouseCmp||''"
          :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.warehouseName.viewable && openWarehouse" slot="warehouseName">
        <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
        <el-select
          ref="warehouseName"
          v-model="form.warehouseName"
          no="warehouseName"
          :disabled="readonly || !elementDict.warehouseName.writable || !warehouseEabled||!form.warehouseCmp"
          :allow-create="true"
          filterable
          :clearable="true"
          @change="warehouseNameChangeHandler"
        >
          <el-option
            v-for="(item,index) in warehouseNameList"
            :key="index"
            :label="item.warehouseName"
            :value="item.warehouseName"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.backUpWarehouse.viewable" slot="backUpWarehouse">
        <line-label slot="label" :class="elementDict.backUpWarehouse.isRequire ? 'blue' : ''" :label="elementDict.backUpWarehouse.label" />
        <cargo-advance-select
          no="backUpWarehouseCmp"
          :select-type="selectTypeNames.basic_data_Company"
          :cache="false"
          :disabled="readonly || !elementDict.backUpWarehouse.writable || !backUpWarehouseEnabled"
          :default-value="form.backUpWarehouseCmp||''"
          filterable
          :static-options="backUpWarehouseCompanyList"
          :placeholder="!backUpWarehouseEnabled? $t('SeaExport.PleaseSelectBackUpWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{pm.backUpWarehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.agentInformation && elementDict.agentInformation.viewable" slot="agentInformation">
        <line-label slot="label" :class="elementDict.agentInformation.isRequire ? 'blue' : ''" :label="elementDict.agentInformation.label" />
        <cargo-textarea v-model="form.agentInformation" no="agentInformation" type="textarea" :row="3" :disabled="readonly || !elementDict.agentInformation.writable" />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.ForeignWarehouse')">
        <cargo-advance-select
          no="overseaWarehouseCode"
          :select-type="selectTypeNames.basic_data_OverseaWarehouse"
          filterable
          :method-params="{ifFba:false}"
          :clearable="false"
          tag-name="countryChineseName"
          tag-value="warehouseCode"
          :default-value="form.overseaWarehouseCode"
          :disabled="readonly"
          style="width:100%;"
          @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.viewable" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTerm"
          :disabled="readonly || !elementDict.freightTerm.writable"
          :class="importDifferenceField.freightTerm ? 'red-border' : ''"
          @parentCallBack="p=>{form.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTermHBL.viewable && !form.mblOnly" slot="freightTermHBL">
        <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
        <cargo-advance-select
          no="freightTermHBL"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTermHBL"
          :disabled="readonly || !elementDict.freightTermHBL.writable"
          :class="importDifferenceField.freightTermHBL ? 'red-border' : ''"
          @parentCallBack="p=>{form.freightTermHBL=p.value;pm.freightTermHBLChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-advance-select
          no="paymentTermMBL"
          :disabled="readonly || !elementDict.paymentTermMBL.writable || !lclslaveEnabled"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="form.paymentTermMBL"
          :class="importDifferenceField.paymentTermMBL ? 'red-border' : ''"
          @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfMblPayment.viewable" slot="placeOfMblPayment">
        <line-label slot="label" :class="elementDict.placeOfMblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfMblPayment.label" />
        <el-input
          v-show="!pm.isShowAcPaymentPlaceBL"
          v-model="mblDoc.paymentPlaceBL"
          no="paymentPlaceBL"
          :disabled="readonly || !elementDict.placeOfMblPayment.writable || !(isEdit && (form.paymentTermMBL==='3P' || form.paymentTermMBL==='PP'))"
          @change="pm.fieldChangeHandler()"
        />
        <cargo-advance-select
          v-if="pm.isShowAcPaymentPlaceBL"
          no="paymentPlaceBL"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="mblDoc.paymentPlaceBL||''"
          :disabled="readonly || !elementDict.placeOfMblPayment.writable"
          @parentCallBack="p=>{mblDoc.paymentPlaceBL = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermHBL.viewable && !form.mblOnly" slot="paymentTermHBL">
        <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
        <cargo-advance-select
          no="paymentTermHBL"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="form.paymentTermHBL"
          :disabled="readonly || !elementDict.paymentTermHBL.writable"
          :allow-create="true"
          :class="importDifferenceField.paymentTermHBL ? 'red-border' : ''"
          @parentCallBack="p=>{pm.paymentSelectHblChange(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfHblPayment.viewable && !form.mblOnly" slot="placeOfHblPayment">
        <line-label slot="label" :class="elementDict.placeOfHblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfHblPayment.label" />
        <el-input v-model="hdoc.paymentPlaceBL" :disabled="readonly || !elementDict.placeOfHblPayment.writable" no="paymentPlaceBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingTerm.viewable" slot="bookingTerm">
        <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
        <el-select
          v-model="form.bookingTerm"
          no="bookingTerm"
          :disabled="readonly || !elementDict.bookingTerm.writable || !pm.bookingTermEditable"
          :placeholder="!pm.bookingTermEditable ? '' : $t('SeaExport.PleaseSelect')"
          :clearable="false"
          size="mini"
          :class="importDifferenceField.bookingTerm ? 'red-border' : ''"
        >
          <el-option
            v-for="(item,index) in bookingTerms"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.viewable" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          filterable
          :clearable="false"
          :default-value="form.incoTerm"
          :disabled="readonly || !elementDict.incoTerm.writable"
          :class="importDifferenceField.incoTerm ? 'red-border' : ''"
          @parentCallBack="p=>{form.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.measurements.viewable" slot="measurements">
        <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
        <el-input
          v-model="form.measurements"
          :disabled="readonly || !elementDict.measurements.writable"
          no="measurements"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.CargoSize'),form.measurements,val=>{form.measurements=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salePriceRemarks.viewable" slot="salePriceRemarks">
        <line-label slot="label" :class="elementDict.salePriceRemarks.isRequire ? 'blue' : ''" :label="elementDict.salePriceRemarks.label" />
        <el-input v-model="form.salePriceRemarks" :disabled="readonly || !elementDict.salePriceRemarks.writable" no="salePriceRemarks" />
      </el-form-item>
      <div v-if="elementDict.businessTags.viewable" slot="businessTags">
        <el-checkbox
          v-model="form.mblOnly"
          :disabled="readonly || !elementDict.businessTags.writable"
          no="mblOnly"
          style="margin: 0"
          @change="pm.isMblOnlyChange()"
        >{{ $t('SeaExport.DirectBusiness') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.transfering"
          no="transfering"
          :disabled="readonly || !elementDict.businessTags.writable || !lclslaveEnabled"
          style="margin: 0"
        >{{ $t('SeaExport.Transport') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.batch"
          no="batch"
          :disabled="readonly || !elementDict.businessTags.writable || !lclslaveEnabled"
          style="margin: 0"
        >{{ $t('SeaExport.InBatches') }}
        </el-checkbox>
        <el-checkbox v-model="form.salePrice" :disabled="readonly || !elementDict.businessTags.writable" no="salePrice" style="margin: 0">{{ $t('SeaExport.SpecialPrice') }}</el-checkbox>
        <el-checkbox
          v-model="form.allocation"
          :disabled="readonly || !elementDict.businessTags.writable"
          style="margin: 0"
          no="allocation"
        >{{ 'Allocation' }}
        </el-checkbox>
        <el-checkbox
          v-model="form.availableCabinSpace"
          :disabled="readonly || !elementDict.businessTags.writable"
          no="availableCabinSpace"
        >{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}
        </el-checkbox>
      </div>
      <!-- 隐藏免柜租期 免堆天数 关区申请 代码撤回-->
      <el-form-item v-if="elementDict.freeDemurrage.viewable" slot="freeDemurrage">
        <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
        <el-input-number v-model="form.freeDemurrage" :disabled="readonly || !elementDict.freeDemurrage.writable" :controls="false" style="width: 100%;" no="freeDemurrage" />
      </el-form-item>
      <el-form-item v-if="elementDict.freeDetention.viewable" slot="freeDetention">
        <line-label slot="label" :class="elementDict.freeDetention.isRequire ? 'blue' : ''" :label="elementDict.freeDetention.label" />
        <el-input-number v-model="form.freeDetention" :disabled="readonly || !elementDict.freeDetention.writable" :controls="false" style="width: 100%;" no="freeDetention" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsAreaApplication.viewable" slot="customsAreaApplication">
        <line-label slot="label" :class="elementDict.customsAreaApplication.isRequire ? 'blue' : ''" :label="elementDict.customsAreaApplication.label" />
        <el-input v-model="form.customsAreaApplication" :disabled="readonly || !elementDict.customsAreaApplication.writable" no="customsAreaApplication" />
      </el-form-item>
      <el-form-item v-if="elementDict.boxOneWay.viewable" slot="boxOneWay">
        <line-label slot="label" :class="elementDict.boxOneWay.isRequire ? 'blue' : ''" :label="elementDict.boxOneWay.label" />
        <el-select v-model="form.boxOneWay" :disabled="readonly || !elementDict.boxOneWay.writable" no="boxOneWay">
          <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="0" />
          <el-option :label="$t('CargoMsg.Cargo_OneWay')" :value="1" />
          <el-option :label="$t('CargoMsg.Cargo_Circulation')" :value="2" />
        </el-select>
      </el-form-item>
      <template v-if="elementDict.seaEq.viewable" slot="seaEq">
        <booking-sea-eq-data-grid
          v-if="form.containerLoadType==='FCL'||form.containerLoadType==='BB'||form.containerLoadType==='BCF'"
          ref="bookingSeaEqDataGrid"
          no="bookingSeaEqDataGrid"
          :value="seaEqList"
          :container-load-type="form.containerLoadType"
          :is-edit="isEdit && elementDict.seaEq.writable"
          :job="form"
          :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
          @eqQuantityChange="eqQuantityChangeHandler"
        />
        <booking-bulk-data-grid
          v-if="form.containerLoadType==='BULK'"
          no="BULK"
          :value="cargoBulkDetailList"
          :context="context"
          :job-uuid="form.uuid"
          :is-edit="isEdit && elementDict.seaEq.writable"
        />
        <booking-special-data-grid
          v-if="form.containerLoadType==='SPA'"
          no="SPA"
          :value="seaEqList"
          :is-edit="isEdit && elementDict.seaEq.writable"
          :job="form"
          @eqQuantityChange="eqQuantityChangeHandler"
        />
      </template>
      <div v-if="elementDict.characteristic && elementDict.characteristic.viewable && showCharacteristic" slot="characteristic" style="display: flex;justify-content: space-around">
        <el-checkbox
          v-model="form.electric"
          :disabled="readonly || !elementDict.characteristic.writable"
          no="electric"
          style="margin: 0"
        >{{ $t('CargoMsg.Electric') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.magnetic"
          :disabled="readonly || !elementDict.characteristic.writable"
          no="magnetic"
          style="margin: 0"
        >{{ $t('CargoMsg.Magnetic') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.powder"
          :disabled="readonly || !elementDict.characteristic.writable"
          no="powder"
          style="margin: 0"
        >{{ $t('CargoMsg.Powder') }}
        </el-checkbox>
        <el-checkbox v-model="form.liquid" :disabled="readonly || !elementDict.characteristic.writable" no="liquid">{{ $t('CargoMsg.Liquid') }}</el-checkbox>
      </div>
      <el-form-item v-show="elementDict.quantityConsignActual.viewable" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.quantityContract"
            no="quantityContract"
            :precision="0"
            :min="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || !isJydEditJobFields"
            :class="importDifferenceField.quantityContract ? 'red-border' : ''"
            @change="pm.jobContractQwcChange(1);calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="quantityActual"
            v-model="form.quantityActual"
            no="quantityActual"
            :precision="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || pm.billChargeFlag || !isJydEditJobFields"
            :min="0"
            :class="importDifferenceField.quantityActual ? 'red-border' : ''"
            @change="quantityActualChange();pm.syncQwcToPoItems(form.quantityActual || 0, null, null)"
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.weightConsignActual.viewable" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.weightContract"
            no="weightContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.weightConsignActual.writable || !isJydEditJobFields"
            :class="importDifferenceField.weightContract ? 'red-border' : ''"
            @change="weightContractChange();calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="weightActual"
            v-model="form.weightActual"
            no="weightActual"
            :precision="3"
            :disabled="readonly || !elementDict.weightConsignActual.writable || pm.billChargeFlag || !isJydEditJobFields"
            :min="0"
            :class="importDifferenceField.weightActual ? 'red-border' : ''"
            @change="weightActualChange();pm.syncQwcToPoItems(null, form.weightActual || 0, null)"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.cubageConsignActual.viewable" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.cubageContract"
            no="cubageContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !isJydEditJobFields"
            :class="importDifferenceField.cubageContract ? 'red-border' : ''"
            @change="cubageContractChange();calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="cubageActual"
            v-model="form.cubageActual"
            no="cubageActual"
            :precision="3"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !cubageActualEnabled || !isJydEditJobFields"
            :min="0"
            :class="importDifferenceField.cubageActual ? 'red-border' : ''"
            @change="cubageActualChange();pm.syncQwcToPoItems(null, null, form.cubageActual || 0)"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item
        v-if="isFba"
        :label="$t('SeaExport.VolumetricWeightConsignActual')"
      >
        <div style="display: flex">
          <auto-number-input
            v-model="form.volumetricWeightContract"
            :disabled="readonly"
            no="volumetricWeightContract"
            :precision="3"
            :min="0"
            @change="calcEstVolumetricAndChargeWeight(form.volumetricWeightContract)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="volumetricWeight"
            v-model="form.volumetricWeight"
            :disabled="readonly"
            no="volumetricWeight"
            :precision="3"
            :min="0"
            @change="changeVolumetricWeight"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item
        v-if="isFba"
        :label="$t('SeaExport.ChargeWeightConsignActual')"
      >
        <div style="display: flex">
          <auto-number-input
            v-model="form.chargeWeightContract"
            :disabled="readonly"
            no="chargeWeightContract"
            :precision="3"
            :min="0"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="chargeWeight"
            v-model="form.chargeWeight"
            :disabled="readonly"
            no="chargeWeight"
            :precision="3"
            :min="0"
            @change="changeChargeWeight"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="isFba" label-width="0">
        <div style="display: flex;justify-content: space-around">
          <el-checkbox v-model="fbaJob.electric" :disabled="readonly" style="margin-right: 10px;margin-left: 20px;">{{ $t('SeaExport.WithElectricity') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.magnetic" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.WithMagnetism') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.powdery" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.Powder') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.liquid" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.Liquid') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantitySize.viewable && form.containerLoadType==='BULK'" slot="insideQuantitySize">
        <line-label slot="label" :class="elementDict.insideQuantitySize.isRequire ? 'blue' : ''" :label="elementDict.insideQuantitySize.label" />
        <auto-number-input
          v-model="form.insideQuantitySize"
          :disabled="readonly || !elementDict.insideQuantitySize.writable"
          no="insideQuantitySize"
          :precision="0"
          style="width:100%;"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.viewable" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :default-value="form.packing"
          :disabled="readonly || !elementDict.packing.writable"
          :class="importDifferenceField.packing ? 'red-border' : ''"
          @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="form.insideQuantity"
          :disabled="readonly || !elementDict.insideQuantity.writable"
          no="insideQuantity"
          :precision="0"
          :min="0"
          :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
          @valCallBack="(val)=>{
            form.insideQuantity = val
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="insidePacking"
          :default-value="form.insidePacking"
          :disabled="readonly || !elementDict.insidePacking.writable"
          @change="p=>{form.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.viewable && !isFba" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.chargeWeight"
            no="chargeWeight"
            :precision="3"
            style="flex:1"
            :disabled="readonly || !elementDict.chargeWeight.writable || !chargeWeightEnabled"
            :min="0"
            :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
            @change="pm.chargeWeightChange();"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
        <el-form-item v-show="isEdit && elementDict.cargoEnglishName.writable">
          <div slot="label">
            <el-button
              no="Copy2"
              type="primary"
              @click="transcribeDialog.visible=true"
            >{{ $t('SeaExport.Copy2') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <special-character-tip :texts="specialCharCheck.cargoEnglishName">
            <div style="position:relative">
              <cargo-textarea
                ref="cargoTextarea1"
                v-model="form.cargoEnglishName"
                no="cargoEnglishName"
                type="textarea"
                :rows="5"
                :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
                wrap-symbol="r"
                auto-half-word
                :auto-uppercase="isUppercaseByConfig"
                :class="importDifferenceField.cargoEnglishName ? 'red-border' : ''"
                @change="onCargoEnglishNameChange"
                @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,form.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
              />
              <char-count :value="form.cargoEnglishName" />
            </div>
          </special-character-tip>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.mark.viewable" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <special-character-tip :texts="specialCharCheck.mark">
          <div style="position:relative">
            <cargo-textarea
              ref="cargoTextarea2"
              v-model="form.mark"
              no="mark"
              type="textarea"
              :rows="5"
              wrap-symbol="r"
              auto-half-word
              :auto-uppercase="isUppercaseByConfig"
              :disabled="!isEdit || !elementDict.mark.writable"
              :class="importDifferenceField.mark ? 'red-border' : ''"
              @change="onMarkChange"
              @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,form.mark,val=>{pm.markChangeHandler(val)},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
            />
            <char-count :value="form.mark" />
          </div>
        </special-character-tip>
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
        <div slot="label">
          <line-label :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.hsCode.writable"
            no="Search"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),val=>{pm.hsCodeChangeHandler(val.code)})"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <el-input
          v-model="form.hsCode"
          :disabled="readonly || !elementDict.hsCode.writable"
          no="hsCode"
          type="textarea"
          :rows="5"
          :class="importDifferenceField.hsCode ? 'red-border' : ''"
          @change="val=>{pm.hsCodeChangeHandler(val)}"
          @dblclick.native="showAdvanceTextDialog(elementDict.hsCode.label,form.hsCode,val=>{pm.hsCodeChangeHandler(val)})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.viewable" slot="cargoChineseName">
        <div slot="label">
          <line-label :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.cargoChineseName.writable"
            no="ChineseDescriptionOfGoods"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>form.cargoChineseName=p.commodityName)"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <div style="position:relative">
          <cargo-textarea
            v-model="form.cargoChineseName"
            no="cargoChineseName"
            :disabled="!isEdit || !elementDict.cargoChineseName.writable"
            type="textarea"
            :rows="5"
            :auto-uppercase="false"
            :auto-half-word="false"
            wrap-symbol="r"
            :class="importDifferenceField.cargoChineseName ? 'red-border' : ''"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,form.cargoChineseName,val=>{form.cargoChineseName=val})"
          />
          <char-count :value="form.cargoChineseName" />
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoCode.viewable" slot="cargoCode">
        <el-form-item class="custom">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="cargoCode"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            :disabled="readonly || !elementDict.cargoCode.writable || canEditInternalDelegatedJobField"
            filterable
            :clearable="true"
            :default-value="form.cargoCode"
            :allow-create="false"
            :class="importDifferenceField.cargoCode ? 'red-border' : ''"
            @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.cargoName"
            no="cargoName"
            :class="importDifferenceField.cargoName ? 'red-border' : ''"
            :disabled="readonly || !elementDict.cargoCode.writable || !(isEdit && form.cargoCode) || canEditInternalDelegatedJobField"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.salesCompany.viewable" slot="salesCompany">
        <line-label slot="label" :class="elementDict.salesCompany.isRequire ? 'blue' : ''" :label="elementDict.salesCompany.label" />
        <el-input
          :value="txtSalesOffice"
          :disabled="true"
          :class="importDifferenceField.salesOffice ? 'red-border' : ''"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.sales.viewable" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <div style="display: flex;justify-content: space-between">
          <cargo-user-select
            ref="sales"
            no="sales"
            :disabled="readonly || !elementDict.sales.writable || !saleEnabled"
            :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
            :default-value="form.sales||''"
            :static-options="salesList"
            :placeholder="salesPrompt"
            :merge-load="true"
            style="flex: 1"
            :class="importDifferenceField.sales ? 'red-border' : ''"
            @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
          />&nbsp;
          <el-checkbox
            v-model="form.provisioned"
            no="provisioned"
            style="margin-left: 5px"
            :disabled="true"
          >{{ fieldDict.provisioned.label }}
          </el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.viewable" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="form.cargoSalesId||''"
          :disabled="readonly || !elementDict.cargoSalesId.writable"
          :merge-load="true"
          :static-options="cargoSalesList"
          :class="importDifferenceField.cargoSalesId ? 'red-border' : ''"
          @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.viewable" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesOffice"
          :disabled="readonly || !elementDict.salesDepartment.writable || !form.sales"
          :sales-id="Number(form.sales)"
          :office-id="form.salesOffice"
          :enables="true"
          :department-id="Number(form.salesDepartment)"
          :class="importDifferenceField.salesDepartment ? 'red-border' : ''"
          @change="p=>{form.salesDepartment=p.value;pm.departmentChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.viewable" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-office-select
          no="opOffice"
          :disabled="readonly || !elementDict.opOffice.writable || (!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
          :is-regional-commission="isRegionalCommission"
          :office-id="Number(form.opOffice)"
          :class="importDifferenceField.opOffice ? 'red-border' : ''"
          @change="p=>{form.opOffice=p.value;form.opDepartment=0;pm.opOfficeChangeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.viewable" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="opDepartment"
          :disabled="readonly || !elementDict.opDepartment.writable || pm.isWithinCloseAccountDate"
          :office-id="Number(form.opOffice)"
          :enables="true"
          :department-id="Number(form.opDepartment)"
          :class="importDifferenceField.opDepartment ? 'red-border' : ''"
          @change="p=>{form.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.op.viewable" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          ref="op"
          no="op"
          :disabled="readonly || !elementDict.op.writable || !opEabled"
          :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
          :default-value="form.op||''"
          :merge-load="true"
          :static-options="userPortRoleData.op"
          :class="importDifferenceField.op ? 'red-border' : ''"
          @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.viewable" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-office-select
          no="csrOffice"
          :disabled="true"
          :office-id="Number(form.csrOffice)"
          :class="importDifferenceField.csrOffice ? 'red-border' : ''"
          @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.viewable" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :office-id="Number(form.csrOffice)"
          :enables="true"
          :department-id="Number(form.csrDepartment)"
          :disabled="readonly || !elementDict.csrDepartment.writable"
          :class="importDifferenceField.csrDepartment ? 'red-border' : ''"
          @change="p=>{form.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.csr.viewable" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          ref="csr"
          no="csr"
          :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
          :default-value="form.csr||''"
          :disabled="readonly || !elementDict.csr.writable"
          :merge-load="true"
          :static-options="userPortRoleData.csr"
          :class="importDifferenceField.csr ? 'red-border' : ''"
          @change="p=>{pm.csrChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.viewable" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
          :default-value="form.siteOP||''"
          :disabled="readonly || !elementDict.siteOP.writable"
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.overseaOp.viewable" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          :default-value="form.overseaOp||''"
          :disabled="readonly || !elementDict.overseaOp.writable"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          :merge-load="true"
          @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.viewable" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-office-select
          no="dcOffice"
          :disabled="true"
          :office-id="Number(form.dcOffice)"
          :class="importDifferenceField.dcOffice ? 'red-border' : ''"
          @change="p=>{form.dcOffice=p.value;form.dcDepartment=0/* ;pm.dcOfficeChangeHandler() */}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.viewable" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :office-id="Number(form.dcOffice)"
          :enables="true"
          :department-id="Number(form.dcDepartment)"
          :disabled="readonly || !elementDict.dcDepartment.writable"
          :class="importDifferenceField.dcDepartment ? 'red-border' : ''"
          @change="p=>{form.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.dc.viewable" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          ref="dc"
          no="dc"
          :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          :disabled="readonly || !elementDict.dc.writable"
          :merge-load="true"
          :static-options="userPortRoleData.doc"
          :class="importDifferenceField.dc ? 'red-border' : ''"
          @change="p=>{pm.dcChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.viewable" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(form.plannerOffice)"
          :class="importDifferenceField.plannerOffice ? 'red-border' : ''"
          @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.viewable" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :office-id="Number(form.plannerOffice)"
          :enables="true"
          :department-id="Number(form.plannerDepartment)"
          :disabled="readonly || !elementDict.plannerDepartment.writable"
          :class="importDifferenceField.plannerDepartment ? 'red-border' : ''"
          @change="p=>{form.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.viewable" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :method-params="{officeId:form.opOffice,category:'role',shape:'seaLine'}"
          :default-value="form.planner||''"
          :disabled="readonly || !elementDict.planner.writable"
          :merge-load="true"
          :static-options="userPortRoleData.seaLine"
          :class="importDifferenceField.planner ? 'red-border' : ''"
          @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          ref="userDefinedRoleId1"
          no="userDefinedRoleId1"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="form.userDefinedRoleId1||''"
          :disabled="readonly || !elementDict.userDefinedRoleId1.writable"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole1"
          @change="p=>{pm.userDefinedRoleId1Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          ref="userDefinedRoleId2"
          no="userDefinedRoleId2"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="form.userDefinedRoleId2||''"
          :disabled="readonly || !elementDict.userDefinedRoleId2.writable"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole2"
          @change="p=>{pm.userDefinedRoleId2Handler(p)}"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-se-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-se-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="form.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{pm.userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="form.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{pm.userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="form.userDefinedRoleId5||''"
          :disabled="readonly"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="form.userDefinedRoleId6||''"
          :disabled="readonly"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="form.userDefinedRoleId7||''"
          :disabled="readonly"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(form.userDefinedRoleId8)"
          :disabled="readonly"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{form.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <special-requests-grid
        v-show="elementDict.satisfiedRequests.viewable"
        slot="satisfiedRequests"
        ref="selectedSpecialRequest"
        v-model="form.satisfiedRequests"
        no="satisfiedRequests"
        :is-edit="isEdit && elementDict.satisfiedRequests.writable"
        :customer-id="Number(form.customerId)"
        :lob="form.lob"
        :job="form"
        style="margin-bottom: 5px"
      />
      <el-form-item v-if="elementDict.operationContent.viewable" slot="operationContent">
        <line-label slot="label" :class="elementDict.operationContent.isRequire ? 'blue' : ''" :label="elementDict.operationContent.label" />
        <el-tooltip
          :content="form.operationContent"
          placement="left"
        >
          <div
            slot="content"
            v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
          />
          <el-input
            no="operationContent"
            :value="form.operationContent"
            :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.operationContent.writable"
            :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
            type="textarea"
            :rows="4"
            @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit||lockJobByPrintHblZb"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.operationTips.viewable" slot="operationTips">
        <line-label slot="label" :class="elementDict.operationTips.isRequire ? 'blue' : ''" :label="elementDict.operationTips.label" />
        <el-input
          v-model="form.operationTips"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.operationTips.writable"
          no="operationTips"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.OperationTips'),form.operationTips,val=>{form.operationTips=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.surchargeTerms.viewable" slot="surchargeTerms">
        <line-label slot="label" :class="elementDict.surchargeTerms.isRequire ? 'blue' : ''" :label="elementDict.surchargeTerms.label" />
        <el-input
          no="txtSurchargeTerms"
          :value="txtSurchargeTerms"
          :disabled="readonly || !elementDict.surchargeTerms.writable"
          :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
          type="textarea"
          :rows="4"
          @dblclick.native="selectSurchargeTermsDialog.rowData=form.surchargeTerms;selectSurchargeTermsDialog.visible=true"
        />
      </el-form-item>
      <!--港前商务负责人-->
      <el-form-item v-if="elementDict.prePortPlanner && elementDict.prePortPlanner.viewable" slot="prePortPlanner">
        <line-label slot="label" :class="elementDict.prePortPlanner.isRequire ? 'blue' : ''" :label="elementDict.prePortPlanner.label" />
        <cargo-user-select
          no="prePortPlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.prePortPlanner||''"
          placeholder=" "
          @change="p=>{pm.prePortPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--尾程商务负责人-->
      <el-form-item v-if="elementDict.lastMilePlanner && elementDict.lastMilePlanner.viewable" slot="lastMilePlanner">
        <line-label slot="label" :class="elementDict.lastMilePlanner.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlanner.label" />
        <cargo-user-select
          no="lastMilePlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.lastMilePlanner||''"
          placeholder=" "
          @change="p=>{pm.lastMilePlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--港前商务负责人部门-->
      <el-form-item v-if="elementDict.prePortPlannerDepartment && elementDict.prePortPlannerDepartment.visible" slot="prePortPlannerDepartment">
        <line-label slot="label" :class="elementDict.prePortPlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerDepartment.label" />
        <cargo-department-select
          no="prePortPlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.prePortPlannerOffice)"
          :enables="true"
          :department-id="Number(form.prePortPlannerDepartment)"
          @change="p=>{form.prePortPlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人部门-->
      <el-form-item v-if="elementDict.lastMilePlannerDepartment && elementDict.lastMilePlannerDepartment.visible" slot="lastMilePlannerDepartment">
        <line-label slot="label" :class="elementDict.lastMilePlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerDepartment.label" />
        <cargo-department-select
          no="lastMilePlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.lastMilePlannerOffice)"
          :enables="true"
          :department-id="Number(form.lastMilePlannerDepartment)"
          @change="p=>{form.lastMilePlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--港前商务负责人公司-->
      <el-form-item v-if="elementDict.prePortPlannerOffice && elementDict.prePortPlannerOffice.visible" slot="prePortPlannerOffice">
        <line-label slot="label" :class="elementDict.prePortPlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerOffice.label" />
        <cargo-advance-select
          no="prePortPlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.prePortPlannerOffice||''"
          @parentCallBack="p=>{form.prePortPlannerOffice=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人公司-->
      <el-form-item v-if="elementDict.lastMilePlannerOffice && elementDict.lastMilePlannerOffice.visible" slot="lastMilePlannerOffice">
        <line-label slot="label" :class="elementDict.lastMilePlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerOffice.label" />
        <cargo-advance-select
          no="lastMilePlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.lastMilePlannerOffice||''"
          @parentCallBack="p=>{form.lastMilePlannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtWhs.viewable" slot="txtWhs">
        <line-label slot="label" :class="elementDict.txtWhs.isRequire ? 'blue' : ''" :label="elementDict.txtWhs.label" />
        <el-input
          no="txtWhs"
          :disabled="true"
          type="textarea"
          :rows="4"
          :value="txtWhs"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.remarks.writable"
          no="remarks"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,form.remarks,val=>{form.remarks=val})"
        />
      </el-form-item>
      <!-- FBA相关信息-->
      <div v-if="isFba" class="section form-column">
        <el-form
          :disabled="readonly"
          label-width="120px"
          label-position="right"
        >
          <span class="title">{{ 'FBA' }}</span>
          <el-form-item v-if="!isEdit" :label="$t('SeaExport.ServiceChannel')">
            <cargo-advance-select
              no="serviceChannel"
              disabled
              :select-type="selectTypeNames.basic_data_FbaChannel"
              filterable
              :method-params="{shippingType: fbaJob.shippingType, active: true}"
              :clearable="true"
              :default-value="fbaJob.serviceChannel"
              @parentCallBack="p=>{fbaJob.serviceChannel=p.value;}"
            />
          </el-form-item>
          <el-form-item v-if="isEdit" :label="$t('SeaExport.ServiceChannel')">
            <el-select v-model="fbaJob.serviceChannel" filterable clearable @change="changeServiceChannel">
              <el-option
                v-for="(item,index) in channel4JobSelect"
                :key="index"
                :label="item.channelName"
                :value="item.channelName"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.EstimatedStorageReadyGoodsTime') }}</span>
            <el-date-picker
              v-model="fbaJob.preWarehousingTime"
              no="preWarehousingTime"
              type="datetime"
              style="width:100%;"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              @change="pm.preWarehousingChangeHandler()"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ExpectedAmazonWarehouseEntryTime')">
            <el-date-picker
              v-model="fbaJob.preAmazonWhTime"
              no="preAmazonWhTime"
              :disabled="readonly"
              type="date"
              style="width:100%;"
              clearable
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
            <div style="display: flex; flex: 1;">
              <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                <el-cascader
                  v-model="fbaJob.warehouseCode"
                  style="width: 91px; padding-right: 2px;"
                  :options="destinations"
                  filterable
                  :clearable="true"
                  @focus="JobUtils.focusWarehouseCode(fbaJob)"
                  @blur="JobUtils.blurWarehouseCode(fbaJob)"
                  @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);changeWarehouseCode}"
                />
              </el-tooltip>
              <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('SeaExport.RemoteWarehouse') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('Warehouse.DestinationCountry')">
            <el-input v-model="fbaJob.country" :disabled="true" no="country" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ZIP')">
            <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DestinationDeliveryMethod')">
            <el-select v-model="fbaJob.destinationDistribution" no="destinationDistribution" filterable @change="destinationDistributionChange">
              <el-option
                v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                :key="index"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('SeaExport.CourierCompany')">
            <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
              <el-option
                v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('SeaExport.TrackingNumber')">
            <el-input v-model="fbaJob.expressNo" no="expressNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.POoriginalNumber')">
            <el-input v-model="fbaJob.poNumber" no="poNumber" />
          </el-form-item>
          <el-form-item :label="'Shipment Id'">
            <el-input v-model="fbaJob.shipmentId" no="shipmentId" />
          </el-form-item>
          <el-form-item :label="'Reference Id'">
            <el-input v-model="fbaJob.referenceId" no="referenceId" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
            <el-radio-group v-model="fbaJob.chargingMethod" no="chargingMethod" @change="chargingMethodChange">
              <el-radio :label="'0'">{{ 'KG' }}</el-radio>
              <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('FbaJob.BubbleCountingRatio')">
            <!--              <el-input-number v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" controls-position="right" :max="999999" :min="0" style="width: 100%;" @change="bubbleCountingChange"/>-->
            <el-input v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" style="width: 100%;" @change="bubbleCountingChange" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.pbProportion')">
            <div style="display: flex; flex: 1;">
              <!--                <el-input-number v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" controls-position="right" :max="10" :min="0" :precision="0" />%-->
              <el-input v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" @change="bubbleSplittingRatioChange" />%
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
            <cargo-advance-select
              no="customsMethodPol"
              :select-type="selectTypeNames.basic_data_CustomsMode"
              :method-params="{serviceType:0}"
              filterable
              :clearable="false"
              :default-value="fbaJob.customsMethodPol"
              @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ClearanceMethod')">
            <cargo-advance-select
              no="customsMethodPod"
              :select-type="selectTypeNames.basic_data_CustomsMode"
              :method-params="{serviceType:1}"
              filterable
              :clearable="false"
              :default-value="fbaJob.customsMethodPod"
              @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.EORIEnterpriseNumber')">
            <el-input v-model="fbaJob.eoriNo" no="eoriNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VATTaxNumber')">
            <el-input v-model="fbaJob.vatNo" no="vatNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VATRegistrationCountry')">
            <cargo-advance-select
              no="taxRegisterCountry"
              :select-type="selectTypeNames.basic_data_Country"
              filterable
              :callback-params="{key:'taxRegisterCountry'}"
              callback-method-type="value"
              :default-value="fbaJob.taxRegisterCountry"
              @parentCallBack="p=>{fbaJob.taxRegisterCountry = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VATRegistrationAddress')">
            <el-input v-model="fbaJob.taxRegisterAddress" no="taxRegisterAddress" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.VATCompanyEnglishName')">
            <el-input v-model="fbaJob.taxCompany" no="taxCompany" />
          </el-form-item>
        </el-form>
      </div>
      <el-form-item v-if="elementDict.userDefinedField1.viewable" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="form.userDefinedField1"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.userDefinedField1.writable"
          no="userDefinedField1"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,form.userDefinedField1,val=>{form.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.viewable" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="form.userDefinedField2"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.userDefinedField2.writable"
          no="userDefinedField2"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,form.userDefinedField2,val=>{form.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.viewable" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="form.userDefinedField3"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.userDefinedField3.writable"
          no="userDefinedField3"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,form.userDefinedField3,val=>{form.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.viewable" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="form.userDefinedField4"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.userDefinedField4.writable"
          no="userDefinedField4"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,form.userDefinedField4,val=>{form.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.viewable" slot="exportControlledProduct">
        <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
        <el-select
          v-model="form.exportControlledProduct"
          no="exportControlledProduct"
          :disabled="readonly || !elementDict.exportControlledProduct.writable"
          :placeholder="form.exportControlledProduct ? '' : $t('SeaExport.PleaseSelect')"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.viewable" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="form.taxNature"
          :disabled="(lockJobByPrintHblZb ? false : readonly) || !elementDict.taxNature.writable"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.viewable" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="form.rateType"
          :disabled="readonly || !elementDict.rateType.writable"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <div v-if="elementDict.shipper.viewable" slot="codeSearching">
        <el-button v-if="!isFba" no="CodeSearching" :disabled="readonly" type="primary" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
        <el-button v-if="isFba" no="FbaCodeSearching" :disabled="readonly" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
      </div>
      <el-form
        v-show="elementDict.shipper.viewable"
        slot="shipper"
        label-width="50px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
            <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-input v-model="form.shipperCode" no="shipperCode" style="width:115px;margin-right: 5px" :class="importDifferenceField.shipperCode ? 'red-border' : ''" :placeholder="readonly ? '' : $t('SeaExport.ShipperId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly || !elementDict.shipper.writable" />
          <cargo-company-select
            no="shipperId"
            :disabled="readonly || !elementDict.shipper.writable"
            :method-params="{shipper:true,active:true}"
            :default-value="form.shipperId||''"
            style="display: inline-block;width:145px;"
            :class="importDifferenceField.shipperId ? 'red-border' : ''"
            @change="data => {pm.shipperChange(data)}"
          />
        </el-form-item>
        <el-form-item
          v-for="i in 7"
          :key="i"
          label-width="0"
        >
          <special-character-tip :texts="specialCharCheck['shipperLine'+i]">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="form['shipperLine'+i]"
              :use-read-only="true"
              :disabled="readonly || !elementDict.shipper.writable"
              :no="'shipperLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :class="importDifferenceField['shipperLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
            />
          </special-character-tip>
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.viewable"
        slot="consignee"
        label-width="65px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
            <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-input v-model="form.consigneeCode" no="consigneeCode" style="width:115px;margin-right: 5px" :class="importDifferenceField.consigneeCode ? 'red-border' : ''" :placeholder="readonly ? '' : $t('SeaExport.ConsigneeId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly || !elementDict.consignee.writable" />
          <cargo-company-select
            no="consigneeId"
            :disabled="readonly || !elementDict.consignee.writable"
            :method-params="{consignee:true,active:true}"
            :default-value="form.consigneeId||''"
            style="display: inline-block;width:145px;"
            :class="importDifferenceField.consigneeId ? 'red-border' : ''"
            @change="data => {pm.consigneeChange(data)}"
          />
        </el-form-item>
        <el-form-item
          v-for="i in 7"
          :key="i"
          label-width="0"
        >
          <special-character-tip :texts="specialCharCheck['consigneeLine'+i]">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="form['consigneeLine'+i]"
              :disabled="readonly || !elementDict.consignee.writable"
              :no="'consigneeLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :class="importDifferenceField['consigneeLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
            />
          </special-character-tip>
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.viewable"
        slot="notify"
        label-width="50px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
            <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-input v-model="form.notifyCode" no="notifyCode" style="width:115px;margin-right: 5px" :class="importDifferenceField.notifyCode ? 'red-border' : ''" :placeholder="readonly ? '' : $t('SeaExport.NotifyId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly || !elementDict.notify.writable" />
          <cargo-company-select
            no="notifyId"
            :disabled="readonly || !elementDict.notify.writable"
            :method-params="{notify:true,active:true}"
            :default-value="form.notifyId||''"
            style="display: inline-block;width:145px;"
            :class="importDifferenceField.notifyId ? 'red-border' : ''"
            @change="data => {pm.notifyChange(data)}"
          />
        </el-form-item>
        <el-form-item
          v-for="i in 7"
          :key="i"
          label-width="0"
        >
          <special-character-tip :texts="specialCharCheck['notifyLine'+i]">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="form['notifyLine'+i]"
              :disabled="readonly || !elementDict.notify.writable"
              :no="'notifyLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :class="importDifferenceField['notifyLine'+i] ? 'red-border' : ''"
              @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
            />
          </special-character-tip>
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="form.alsoNotify"
          no="alsoNotify"
          :disabled="readonly || !elementDict.alsoNotify.writable"
          type="textarea"
          wrap-symbol="r"
          :class="importDifferenceField.alsoNotify ? 'also-notify red-border' : 'also-notify'"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify,{warningCount:45,maxChar: 0,autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
        />
      </div>
      <el-form-item v-if="elementDict.loadingAgentId && elementDict.loadingAgentId.viewable" slot="loadingAgentId">
        <line-label slot="label" :class="elementDict.loadingAgentId.isRequire ? 'blue' : ''" :label="elementDict.loadingAgentId.label" />
        <cargo-company-select
          no="loadingAgentId"
          :method-params="{localAgent:true,active: true}"
          :disabled="readonly || !elementDict.loadingAgentId.writable"
          :default-value="form.loadingAgentId||''"
          :data-filter-function="JobUtils.loadingAgentIdFilter"
          :tag-name="isZh ? 'chineseName' : 'englishName'"
          @change="p=>{form.loadingAgentId = p.value}"
        />
      </el-form-item>
    </tab-booking-FCLUICustom-layout>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ContactPerson"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="SE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="selectOperationReqDialog.value"
      @callback="val=>form.operationContent=val"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingFCLUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBookingFCL from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabBookingFCLUICustom',
  components: { cargoTextarea, tabBookingFCLUICustomLayout },
  extends: tabBookingFCL,
  props: {
    previewConfig: { type: Object, default: null },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.form ? this.form.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      },
      scacList: [],
      carrierScacEdit: false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'form.bookingTerm': {
      handler(newVal) {
        this.pm.bookingTermChange(newVal)
      }
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }

  },
  async created() {
    this.loadPageConfig()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
    this.scacList = await JobUtils.getScacList(this.form.carrierScac)
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.$route.name === 'BookingVerify' ? UICustomConstants.SEA_VERIFY_BOOKING_BASIC : UICustomConstants.SEA_BOOKING_BASIC
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row, false)
        if (!row.uuid) {
          this.onFieldChange('etd')
        }
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageType = this.$route.name === 'BookingVerify' ? UICustomConstants.SEA_VERIFY_BOOKING_BASIC : UICustomConstants.SEA_BOOKING_BASIC
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId, false)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
      this.carrierScacEdit = JobUtils.checkCarrierScacEdit(this.elementDict)
    },
    async validateForm() {
      const form = this.form
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (fieldName === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (fieldName === 'projectName' || fieldName === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (fieldName === 'warehouseName') {
            if (!this.openWarehouse) {
              continue
            }
          }
          if (fieldName === 'freightTermHBL' || fieldName === 'paymentTermHBL') {
            if (form.mblOnly) {
              continue
            }
          }
          if (fieldName === 'userDefinedRoleId1' || fieldName === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (fieldName === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (fieldName === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (fieldName === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (fieldName.startsWith('shipperLine') || fieldName.startsWith('consigneeLine') || fieldName.startsWith('notifyLine')) {
            continue
          }
          if (fieldName.startsWith('shipperCode') || fieldName.startsWith('consigneeCode') || fieldName.startsWith('notifyCode')) {
            continue
          }
          if (fieldName === 'transferPortCode') {
            if (form.transfering && StrUtils.isEmpty(form.transferPortCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (fieldName === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.viewable && this.elementDict.seaEq.writable && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'FCL' || (form.containerLoadType === 'BB' && !this.isXy) || form.containerLoadType === 'BCF' || form.containerLoadType === 'SPA') {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBookingFCL')
          }
          if (form.containerLoadType === 'SPA') {
            for (const seaEq of this.seaEqList) {
              if (!seaEq.eqQuantity) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBookingFCL')
              }
              if (!seaEq.sizeLength || !seaEq.sizeWidth || !seaEq.sizeHeight) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Dimension')]), 'tabBookingFCL')
              }
            }
          } else {
            for (const seaEq of this.seaEqList) {
              if (!seaEq.eqQuantity) {
                throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBookingFCL')
              }
            }
          }
        } else if (form.containerLoadType === 'BULK') { // 散杂货
          // if (!this.cargoBulkDetailList || this.cargoBulkDetailList.length === 0) {
          //   throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBookingFCL')
          // }
          // for (const bulk of this.cargoBulkDetailList) {
          //   if (!bulk.insideQuantity) {
          //     throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Pieces')]), 'tabBookingFCL')
          //   }
          //   if (!bulk.sizeLength || !bulk.sizeWidth || !bulk.sizeHeight) {
          //     throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Dimension')]), 'tabBookingFCL')
          //   }
          //   if (!bulk.cubage) {
          //     throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Cubage2')]), 'tabBookingFCL')
          //   }
          //   if (!bulk.weight) {
          //     throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Weight2')]), 'tabBookingFCL')
          //   }
          // }
        }
      }
      if (this.elementDict.haulageCompany && this.elementDict.haulageCompany.viewable && this.elementDict.haulageCompany.writable && this.elementDict.haulageCompany.isRequire) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.haulageCompany.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.viewable && this.elementDict.warehouseCmp.writable && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.warehouseName && this.elementDict.warehouseName.viewable && this.elementDict.warehouseName.writable && this.elementDict.warehouseName.isRequire && this.openWarehouse) {
        if (StrUtils.isEmpty(this.form.warehouseName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseName.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.backUpWarehouse && this.elementDict.backUpWarehouse.viewable && this.elementDict.backUpWarehouse.writable && this.elementDict.backUpWarehouse.isRequire) {
        if (!form.backUpWarehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.backUpWarehouse.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.surchargeTerms && this.elementDict.surchargeTerms.viewable && this.elementDict.surchargeTerms.writable && this.elementDict.surchargeTerms.isRequire) {
        if (StrUtils.isEmpty(this.txtSurchargeTerms)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.surchargeTerms.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.satisfiedRequests && this.elementDict.satisfiedRequests.viewable && this.elementDict.satisfiedRequests.writable && this.elementDict.satisfiedRequests.isRequire) {
        if (StrUtils.isEmpty(form.satisfiedRequests)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.satisfiedRequests.label]), 'tabBookingFCL')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.form.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-se-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.form.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-se-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.form.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.form.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.form.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.form.userDefinedRoleId4)
          }
        }
      }
    },
    onFieldChange(fieldName) {
      if (this.$route.name === 'BookingVerify') {
        // UICustomUtil.handleFieldChange(UICustomConstants.SEA_VERIFY_BOOKING_MODULE, UICustomConstants.SEA_VERIFY_BOOKING_BASIC, this.form, fieldName, this.context.modifiedData)
      } else {
        UICustomUtil.handleFieldChange(UICustomConstants.SEA_BOOKING_MODULE, UICustomConstants.SEA_BOOKING_BASIC, this.form, fieldName, this.context.modifiedData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouseClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
/deep/ .also-notify {
  width: 310px;
  .el-textarea__inner {
    height: 230px;
  }
}

.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea {
    border: 1px solid red !important;
  }
}
</style>
